const AppConfigActionTypes = {
  SET_CURRENT_LANGUAGE: 'SET_CURRENT_LANGUAGE'
};

export default AppConfigActionTypes;
